import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

export interface DeadLetterFilterState {
  searchTerm: string;
  eventType: string;
  dateFrom: Date | null;
  dateTo: Date | null;
}

@Component({
    selector: 'app-dead-letter-filters',
    templateUrl: './dead-letter-filters.component.html',
    styleUrls: ['./dead-letter-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterFiltersComponent implements OnInit, OnDestroy {
  @Input() filters: DeadLetterFilterState = { searchTerm: '', eventType: '', dateFrom: null, dateTo: null };
  @Output() filtersChange = new EventEmitter<DeadLetterFilterState>();

  private readonly searchTerm$ = new Subject<string>();
  private readonly eventType$ = new Subject<string>();
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.searchTerm$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(term => {
      this.filtersChange.emit({ ...this.filters, searchTerm: term });
    });

    this.eventType$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(eventType => {
      this.filtersChange.emit({ ...this.filters, eventType });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchTermChange(value: string): void {
    this.searchTerm$.next(value);
  }

  onEventTypeFilterChange(value: string): void {
    this.eventType$.next(value);
  }

  onDateFromChange(value: Date | null): void {
    this.filtersChange.emit({ ...this.filters, dateFrom: value });
  }

  onDateToChange(value: Date | null): void {
    this.filtersChange.emit({ ...this.filters, dateTo: value });
  }
}
